<template>
  <!-- Payment information -->
  <div class="paymentInformation">
    <!-- 单价、定时刷新数据时间 -->
    <div class="feeTitle">
      <div class="feeTitle-value">
        <template v-if="showLoading">
          <div class="loading-svg">
            <button-loading class="rightIcon" />
          </div>
          <div class="feeTitle-value-text">{{ $t('buyFee_components.updatingRates') }}</div>
        </template>
        <template v-else>
          <div class="loading-svg">
            <img src="@/assets/images/SellTime.svg" alt="" />
          </div>
          <div class="feeTitle-value-text" v-html="$t('buyFee_components.updateIn', [timeDownNumber])"></div>
        </template>
      </div>
    </div>
    <!-- 详细费用信息 -->
    <div class="fee-content">
      <div class="fee-content-title" @click="expandCollapse">
        <div class="left">
          {{ $t('buyFee_components.youOrder') }}
        </div>
        <div class="right">
          <span>{{ routerParams.amount }} {{ currencyData.name }}</span> {{ $t('sellFee_components.title2') }} <span>{{ routerParams.getAmount }} {{ positionData.code }}</span>
          <div class="img-box">
            <img :class="{ rotate: detailsState }" :src="imageBottom" />
          </div>
        </div>
      </div>
      <!-- 详细费用信息 -->
      <el-collapse-transition>
        <div class="fee-content-details" v-show="detailsState">
          <div class="fee-content-details-line">
            <div class="title">1 {{ currencyData.name }}</div>
            <div class="value">≈ {{ price }} {{ positionData.code }}</div>
          </div>

          <div class="fee-content-details-line">
            <div class="title">
              {{ $t('sellFee_components.rampFee') }}
              <el-popover :close-delay="1" placement="top-start" :offset="55" :trigger="triggerType">
                <p>{{ $t('sellFee_components.tips') }}</p>
                <div slot="reference"><img class="tipsIcon" src="@/assets/images/exclamatoryMarkIcon.svg" /></div>
              </el-popover>
            </div>
            <div class="value">
              <span class="minText">{{ $t('sellFee_components.RampFeeTips') }} &nbsp;</span>
              {{ feeInfo.fiatSymbol }}&nbsp;{{ rampFee }}
            </div>
          </div>
        </div>
      </el-collapse-transition>
    </div>
  </div>
</template>

<script>
/**
 * 卖币费用组件
 * isHome 是否是首页使用
 */
import { mapState } from 'vuex';
import { mathJs } from '@/utils';
import common from '../../utils/common';

export default {
  name: 'includedDetails',
  props: {
    isHome: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      triggerType: 'hover',
      detailsState: false,

      timeDown: 60,
      timeOut: null,
      feeParams: {},
      feeInfo: {},
      routerParams: {},
      currencyData: {},
      positionData: {},
      timeDownNumber: 15,
      imageBottom: require('@/assets/images/blackDownIcon1.svg'),
      showLoading: false
    };
  },
  watch: {
    //输入金额改变后刷新数据
    '$store.state.sellRouterParams.amount': {
      deep: true,
      handler() {
        //模拟防抖输入完成之后再触发
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.timingSetting();
        }, 500);
      }
    },
    //选择国家后刷新数据
    '$store.state.sellRouterParams.payCommission.fiatCode': {
      deep: true,
      handler() {
        this.$parent.getAmount = '';
        this.timingSetting();
      }
    },
    //选择数字货币后刷新数据
    '$store.state.sellRouterParams.currencyData.name': {
      deep: true,
      handler() {
        this.$parent.getAmount = '';
        this.timingSetting();
      }
    }
  },
  mounted() {
    //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
    this.triggerType = common.equipmentEnd === 'pc' ? 'hover' : 'click';
    this.timingSetting();
  },
  activated() {
    //判断是pc还是移动端，用于展示的提示信息是click还是hover触发
    this.triggerType = common.equipmentEnd === 'pc' ? 'hover' : 'click';
    if (this.isHome && this.isHome === true) {
      this.timingSetting();
    }
  },
  destroyed() {
    window.clearInterval(this.timeOut);
    this.timeOut = null;
  },
  deactivated() {
    window.clearInterval(this.timeOut);
    this.timeOut = null;
  },
  computed: {
    //卖币信息
    ...mapState('sellPayments',{
      sellPayType: state => state.sellPayType,
    }),

    price() {
      let decimalDigits = 0;
      let resultValue = this.feeInfo.price * this.feeInfo.rateUsd;
      resultValue >= 1 ? (decimalDigits = 2) : (decimalDigits = 6);
      let price = resultValue ? resultValue.toFixed(decimalDigits) : '';
      isNaN(resultValue) || price <= 0 ? (price = 0) : '';
      return price;
    },
    rampFee() {
      let decimalDigits = 0;
      let resultValue = this.feeInfo.rampFee;
      resultValue >= 1 ? (decimalDigits = 2) : (decimalDigits = 6);
      let rampFee = resultValue ? resultValue.toFixed(decimalDigits) : '';
      isNaN(resultValue) || rampFee <= 0 ? (rampFee = 0) : '';
      return rampFee;
    }
  },
  methods: {
    //15秒定时刷新费用数据
    timingSetting() {
      this.currencyData = this.$store.state.sellRouterParams.currencyData;
      this.positionData = this.$store.state.sellRouterParams.positionData;
      this.routerParams = this.$store.state.sellRouterParams;
      window.clearInterval(this.timeOut);
      this.timeOut = null;
      this.queryFee();
      this.timeOut = setInterval(() => {
        if (this.timeDownNumber === 1) {
          this.timeDownNumber = '';
          this.showLoading = true;
          setTimeout(() => {
            this.showLoading = false;
            this.timeDownNumber = 15;
            this.queryFee();
          }, 500);
        } else {
          this.timeDownNumber -= 1;
        }
      }, 1000);
    },
    //获取费用数据
    queryFee() {
      let params = JSON.parse(JSON.stringify(this.$store.state.feeParams));
      params.amount = this.$store.state.sellRouterParams.amount;
      //存在商户信息入参添加appId
      let accessMerchantInfo = sessionStorage.getItem('buyMerchantInfo');
      let merchantType = sessionStorage.getItem('merchantType');
      if (accessMerchantInfo !== undefined && accessMerchantInfo && JSON.parse(accessMerchantInfo).merchantParam_state && JSON.parse(accessMerchantInfo).appId && merchantType === 'sell') {
        params.appId = JSON.parse(accessMerchantInfo).appId;
      }
      //控制卖币首页按钮禁用
      if (this.isHome && this.isHome === true && this.timeDownNumber !== 15) {
        this.$parent.exchange = true;
      }
      if (!this.isHome) {
        params.payWayCode = this.sellPayType.payWayCode;
      }
      //首页切换金额时将按钮禁用
      this.$axios.get(this.$api.get_inquiryFeeSell, params).then(res => {
        if (res && res.data) {
          // console.log('res343', JSON.stringify(res));
          this.$store.state.sellRouterParams.currencyData.price = res.data.price;
          this.feeInfo = res.data;
          //修改首页费用数据
          if (this.isHome && this.isHome === true) {
            this.$parent.feeInfo = this.feeInfo;
            // let decimalDigits = 0;
            // let resultValue = Number(res.data.fiatAmount) - Number(res.data.rampFee);
            let resultValue = mathJs(res.data.fiatAmount).subtract(res.data.rampFee).done();
            // resultValue >= 1 ? (decimalDigits = 2) : (decimalDigits = 6);
            // let getAmount = resultValue ? resultValue.toFixed(decimalDigits) : '';
            let getAmount = resultValue;
            isNaN(resultValue) || getAmount <= 0 ? (getAmount = 0) : '';

            this.$parent.getAmount = getAmount;
            // if(this.$route.path === '/'){
            //   this.$parent.exchange = false
            this.$parent.warningTextState = true;
            if ((this.$parent.payAmount === '' || this.$parent.payAmount <= 0) && this.$parent.getAmount) {
              // this.$parent.getAmount = ''
            }
            // }
            this.$parent.currencyData.minSell = res.data.minAmount;
            this.$parent.currencyData.maxSell = res.data.maxAmount;
            this.$store.state.sellRouterParams.getAmount = getAmount;
          }
        }
      });

      // this.$axios.get(this.$api.get_inquiryFeeSell, params).then(res => {
      //   if (res && res.data) {
      //     console.log('res343', JSON.stringify(res));
      //     this.$store.state.sellRouterParams.currencyData.price = res.data.price;
      //     this.feeInfo = res.data;
      //     //修改首页费用数据
      //     if (this.isHome && this.isHome === true) {
      //       this.$parent.feeInfo = this.feeInfo;
      //       let decimalDigits = 0;
      //       let resultValue = res.data.fiatAmount - res.data.rampFee;
      //       resultValue >= 1 ? (decimalDigits = 2) : (decimalDigits = 6);
      //       let getAmount = resultValue ? resultValue.toFixed(decimalDigits) : '';
      //       isNaN(resultValue) || getAmount <= 0 ? (getAmount = 0) : '';
      //       this.$parent.getAmount = getAmount;
      //       // if(this.$route.path === '/'){
      //       //   this.$parent.exchange = false
      //       this.$parent.warningTextState = true;
      //       if ((this.$parent.payAmount === '' || this.$parent.payAmount <= 0) && this.$parent.getAmount) {
      //         // this.$parent.getAmount = ''
      //       }
      //       // }
      //       this.$store.state.sellRouterParams.getAmount = getAmount;
      //     }
      //   }
      // });
    },

    //展开费用信息
    expandCollapse() {
      this.detailsState = !this.detailsState;
      if (this.detailsState) {
        setTimeout(() => {
          this.$parent.$refs.includedDetails_ref.$el.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' });
        });
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.paymentInformation {
  .feeTitle {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .feeTitle-value {
      display: flex;
      align-items: center;
      height: 0.14rem;

      ::v-deep .loading-svg {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 0.12rem;
          height: 0.12rem;
          margin-right: 0.04rem;
        }
        .rightIcon {
          margin-right: 0.04rem;
          width: 0.12rem;
          height: 0.12rem;
          display: flex;
          align-items: center;
          justify-content: center;
          svg {
            width: 0.12rem;
            height: 0.12rem;
            .path {
              stroke: #848b96;
            }
          }
        }
      }
      ::v-deep .feeTitle-value-text {
        font-family: 'SF Pro Display';
        font-style: normal;
        font-weight: 400;
        font-size: 0.11rem;
        line-height: 0.13rem;
        color: #848b96;
        display: flex;
        text-align: center;
        justify-content: center;

        span {
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          width: 0.12rem;
        }
      }
    }
  }

  .fee-content {
    margin-top: 0.07rem;
    transition: all 0.3s;
    .fee-content-title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        align-items: center;
        font-family: 'SF Pro Display';
        font-style: normal;
        font-weight: 500;
        font-size: 0.14rem;
        line-height: 0.22rem;
        color: #252830;
      }
      .right {
        display: flex;
        align-items: center;
        font-family: 'SF Pro Display';
        font-style: normal;
        font-weight: 500;
        font-size: 0.14rem;
        line-height: 0.22rem;
        color: #252830;
        span {
          color: #252830;
          font-size: 0.14rem;
          font-family: 'HarmonyOS Sans';
          font-weight: 700;
          padding: 0 0.02rem;
        }
        .img-box {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 0.08rem;
          img {
            display: block;
            transition: all 0.3s;
            transform: rotate(0deg);
            &.rotate {
              transform: rotate(180deg);
            }
          }
        }
      }
    }

    .fee-content-details {
      overflow: hidden;
      transition-duration: 0.3s !important;
      transition-timing-function: ease !important;
      padding-bottom: 1px;

      .fee-content-details-line {
        display: flex;
        align-items: center;
        margin-top: 0.1rem;
        &:first-child {
          margin-top: 0.14rem;
        }
        .title {
          display: flex;
          align-items: center;
          font-family: 'HarmonyOS Sans';
          font-style: normal;
          font-weight: 400;
          font-size: 0.12rem;
          line-height: 0.14rem;
          color: #252830;
          .tipsIcon {
            width: 0.14rem;
            height: 0.14rem;
            margin-left: 0.04rem;
            display: flex;
            cursor: pointer;
          }
        }

        .value {
          margin-left: auto;
          display: flex;
          align-items: center;
          font-family: 'HarmonyOS Sans';
          font-style: normal;
          font-weight: 400;
          font-size: 0.12rem;
          line-height: 0.14rem;
          color: #252830;
          .minText {
            // font-family: Regular;
            // font-weight: 400;
            // color: #c2c2c2;
            // margin-right: 0.04rem;
            // margin-top: -0.02rem;
          }
        }
      }
    }
    &.opacity6 {
      opacity: 0.5;
    }
  }
}
</style>
